import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9d540fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "warning-title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "预警图片集")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "retrospect"
}
const _hoisted_4 = { class: "warning-img" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-charutupian" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-chakanxiangqing" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看图片", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "retrospect-info" }
const _hoisted_10 = { class: "retrospect-info-item" }
const _hoisted_11 = { class: "retrospect-info-item" }
const _hoisted_12 = { class: "retrospect-info-item" }
const _hoisted_13 = { class: "retrospect-info-item" }
const _hoisted_14 = { class: "warning-title" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "预警视频回放", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("查看完整视频")
const _hoisted_17 = { class: "uni-btn-v" }

import { ref, onMounted, nextTick, watch } from 'vue'
import { RouterLink, useRoute, useRouter } from 'vue-router'
import { ImagePreview, Dialog } from 'vant'
import { useStore } from 'vuex'

import { getWarningById, delWarn } from '@/api/shop'
import { getBase64Image } from '@/utils'
import { IRetrospect } from '@/utils/interface'
import ComHeader from '@/components/ComHeader/index.vue'
import ComVideo from '@/components/ComVideo/index.vue'
// import ComVideo2 from '@/components/ComVideo/index_test.vue'
// import imgBox from '@/components/imgBox/index.vue'
// import html2canvas from 'html2canvas'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()
const data = ref<IRetrospect>()
// const imageUrl = ref('')

const init = () => {
  getWarningById({
    id: route.params.id
  }).then((res: any) => {
    data.value = res
  })
}
watch(
  () => router.currentRoute.value.path,
  (newVal: string) => {
    if (newVal.indexOf('/retrospect') !== -1) {
      init()
    }
  },
  {
    immediate: true
  }
)

// const handleImage = (url: string, callback: any) => {
//   const image = new Image()
//   image.setAttribute('crossOrigin', 'anonymous')
//   // @ts-ignore
//   image.src = url
//   image.onload = function () {
//     imageUrl.value = getBase64Image(image)
//     callback && callback()
//   }
// }

// const showImg = () => {
//   console.log('imageUrl', url.value)
//   url.value &&
//     ImagePreview({
//       // images: [data.value?.imageUrl],
//       images: [url.value],
//       closeable: true,
//       closeIconPosition: 'bottom-left'
//     })
// }
const showImg = () => {
  data.value &&
    ImagePreview({
      // images: [data.value?.imageUrl],
      images: [data.value.imageUrl],
      closeable: true,
      closeIconPosition: 'bottom-left'
    })
}

const delItem = () => {
  Dialog.confirm({
    title: '提醒',
    message: '是否确认删除'
  })
    .then(() => {
      delWarn(route.params.id as string).then((res: any) => {
        console.log(res)
        router.back()
      })
    })
    .catch(() => {
      // on cancel
    })
}
// const img = ref<HTMLElement | null>(null)
// const url = ref('')

const goTo = () => {
  if (data.value?.record) {
    router.push(`/task/detail?id=${data.value.recordId}`)
  } else {
    router.push(`/task/add?id=${route.params.id}`)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ComHeader, {
      height: 16,
      title: "预警追溯"
    }),
    _hoisted_2,
    (data.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_image, {
              width: "100%",
              height: "100%",
              fit: "cover",
              position: "center",
              src: data.value.imageUrl
            }, null, 8, ["src"]),
            _hoisted_5,
            _createElementVNode("div", {
              class: "button",
              onClick: showImg
            }, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, " 检测类型：" + _toDisplayString(data.value.exceptionDescribe), 1),
            _createElementVNode("div", _hoisted_11, " 设备ID：" + _toDisplayString(data.value.deviceSerial), 1),
            _createElementVNode("div", _hoisted_12, " 发生日期：" + _toDisplayString(data.value.time), 1),
            _createElementVNode("div", _hoisted_13, " 发生地点：" + _toDisplayString(data.value.storeName) + "/" + _toDisplayString(data.value.addressName), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createVNode(_unref(RouterLink), {
        class: "warning-title-link",
        to: `/retrospect/video/${_unref(route).params.id}`
      }, {
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    (data.value && data.value.videoUrl && _unref(store).getters.tenantType !== 'daHua')
      ? (_openBlock(), _createBlock(ComVideo, {
          key: 1,
          imageUrl: data.value.imageUrl,
          videoUrl: data.value.videoUrl
        }, null, 8, ["imageUrl", "videoUrl"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_van_button, {
        onClick: goTo,
        block: "",
        class: "com-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(data.value && data.value.record ? '查看任务' : '生成任务'), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})